<template>
<div class="scrollable">
  <div class="svg-img" v-for="svg in svgs" :key="svg">
    <inline-svg
      :src="svg"
      v-on:click="svgSelected(svg)"
      :transformSource="transform"
      width="65"
      fill="black"
      height="65"
      aria-label="Select image"
  ></inline-svg>
  </div>
</div>
</template>

<script>
import axios from "axios";

const drupalUrl = "https://itemizr.gravurapp.com";
import InlineSvg from 'vue-inline-svg';

export default {
  name: 'IconPicker',
  components: {
    InlineSvg
  },
  props: {
    event: String
  },
  data: function() {
    return {
      svgs: [],
      loading: true,
    }
  },
  mounted: function() {
    // Currently the event id is hard-coded as the API only returns one event
    // TODO: You need to update this as we have more events.
    // TODO 1 -> See Readme.md
    const url =
      `${drupalUrl}/api/v1/events/${this.event}?include=field_graphics`;
    axios.get(url).then(res => {
      const graphicIds = res.data.included.map(i => i.id);
      return graphicIds;
    })
    .then(ids => {
      const defers = [];
      for (let id of ids) {
        defers.push(axios.get(`${drupalUrl}/api/v1/graphics/${id}?include=field_graphic_image`));
      }
      return Promise.all(defers);
    })
    .then(results => {
      const fileUrls = results.map(res => res.data.included[0].links.self.href);
      return fileUrls;
    })
    .then(urls => {
      const defers = [];
      for (let url of urls) {
        defers.push(axios.get(url));
      }
      return Promise.all(defers)
    })
    .then(fileResults => {
      return fileResults.map(res => drupalUrl + res.data.data.attributes.uri.url);
    })
    .then(graphics => {
      this.loading = false;
      this.svgs = graphics;
    });
  },
  methods: {
    svgSelected(url) {
      this.$emit('svg', url);
    },
    transform(svg) {
      // svg.style.fill = '#000000';

      // const paths = svg.querySelector('path');
      // for (let i = 0; i < paths.length; ++i) {
      //   paths[i].setAttribute('fill', '#000000');
      // }
      return svg;
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  cursor: pointer;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #979797;
}
.scrollable {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-items: center;
  max-height: 60vh;
  min-height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}
</style>
